import { t } from "@travily/i18n";
import familyIllustration from "@ui/assets/illustrations/family-animated.webp";
import { TileRadioGroup } from "@ui/components/TileRadioGroup";
import { Wizard } from "@ui/components/Wizard";
import { useBreakpoint } from "@ui/hooks/use-breakpoint";
import type { ReactNode } from "react";

const COLOR = "red" as const;

export interface FamilyPrivacyStepViewProps {
  currentStage: number;
  totalStages: number;
  value: "public" | "private";
  primaryPending: boolean;
  topBarActions: ReactNode;
  onBack?: () => void;
  onPrimary: () => void;
  onChange: (value: string) => void;
}

export const FamilyPrivacyStepView = ({
  currentStage,
  totalStages,
  value,
  primaryPending,
  topBarActions,
  onBack,
  onPrimary,
  onChange,
}: FamilyPrivacyStepViewProps) => {
  const isAboveMd = useBreakpoint("md");
  const isAboveLg = useBreakpoint("lg");
  const selectionGroupSize = isAboveLg ? "5xl" : isAboveMd ? "4xl" : "3xl";

  const radioItems = [
    { value: "public", label: t("web.families.creator.steps.privacy.show.options.public") },
    { value: "private", label: t("web.families.creator.steps.privacy.show.options.private") },
  ];

  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage
        illustration={<img alt="" aria-hidden="true" src={familyIllustration} />}
        heading={t("web.families.creator.steps.privacy.show.title")}
      >
        <TileRadioGroup
          className="w-full max-w-[600px] gap-5"
          color={COLOR}
          onChange={onChange}
          size={selectionGroupSize}
          value={value}
        >
          {radioItems.map((item) => (
            <TileRadioGroup.Item key={item.value} value={item.value}>
              {item.label}
            </TileRadioGroup.Item>
          ))}
        </TileRadioGroup>
      </Wizard.Stage>
    </Wizard>
  );
};
